import { render, staticRenderFns } from "./DpadList1.vue?vue&type=template&id=e5d11696"
import script from "./DpadList1.vue?vue&type=script&lang=js"
export * from "./DpadList1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports